import {EntityWithId} from "../baseEntities";

export enum ClientSolicitationFlowFields {
    SolicitationId = 'intIdSolicitud',
    Date = 'dtmFecha',
    Incomes = 'decIngresos',
    Sales = 'decVentas'
}


export interface ClientSolicitationFlow extends EntityWithId<number> {
    [ClientSolicitationFlowFields.SolicitationId]: number,
    [ClientSolicitationFlowFields.Incomes]: number,
    [ClientSolicitationFlowFields.Sales]: number,
    [ClientSolicitationFlowFields.Date]: Date
}


export interface ClientSolicitationFlowForm {
    [ClientSolicitationFlowFields.Incomes]: number | null,
    [ClientSolicitationFlowFields.Sales]: number | null,
    [ClientSolicitationFlowFields.Date]: Date | null
}